module.exports = __webpack_public_path__ + "static/media/view_table.e07f434d.svg";